module.exports = __webpack_public_path__ + "static/cpe-c9e023b921a29c26deb06146ad45d2c5.jpg";